export default "__VITE_ASSET__CeKY5aUq__"